import React, { useState } from "react";
import { ReactComponent as PendingIcon } from "../../../Assets/Icons/pendingIcon.svg";
import { ReactComponent as DeleteIcon } from "../../../Assets/Icons/deleteIcon.svg";
import { ReactComponent as MapIcon } from "../../../Assets/Icons/MapIcon.svg";
import { ReactComponent as MailIcon } from "../../../Assets/Icons/mailIcon.svg";
import { ReactComponent as WebIcon } from "../../../Assets/Icons/webIcon.svg";
import { ReactComponent as UserIcon } from "../../../Assets/Icons/userIcon.svg";
import { ReactComponent as PhoneIcon } from "../../../Assets/Icons/phoneIcon.svg";
import { ReactComponent as CategoryIcon } from "../../../Assets/Icons/categoryIcon.svg";
import { ReactComponent as CurrencyIcon } from "../../../Assets/Icons/currencyIcon.svg";
import "../../common/OfferList/offerList.scss";
import { ReactComponent as ApprovedIcon } from "../../../Assets/Icons/approveIcon.svg";
import { ReactComponent as DeclinedIcon } from "../../../Assets/Icons/declinedIcon.svg";
import { ReactComponent as DownArrow } from "../../../Assets/Icons/blackDownArrow.svg";
import { DatePicker } from "antd";
import { toast } from "react-toastify";
import dayjs from "dayjs";
import TargetsTable from "./TargetsTable";
import PrimaryButton from "../../common/PrimaryButton";
import PrimaryOutlineButton from "../../common/PrimaryOutlineButton";
// Decline modal is handled at parent level; keep this content focused on details
import { bulkStatusUpdate, approveOrRejectFundraiser } from "../../../services/fundraiserService";
import { useDispatch } from "react-redux";
import profileImagePlaceholderBlue from "../../../Assets/Images/PersonBlue.svg";
import { config as s3Config } from "../../../utils/s3";



const PopupContent = ({
  merchantDetails,
  setSelectedYear,
  selectedYear,
  handleYearChange,
  onDelete,
  onShowReviewModal,
  onDecline,
  onStatusChange,
}) => {
  const dispatch = useDispatch();
  const [statusToggled, setStatusToggled] = useState(false);

  if (!merchantDetails) {
    return (
      <div className="flex flex-col items-center justify-center min-h-[400px]">
        <div className="loader"></div>
        <p className="mt-4 text-[#767676] font-poppins text-[15px]">Loading fundraiser details...</p>
      </div>
    );
  }

  const {
    address,
    contactPersonName,
    contactPersonNumber,
    logo,
    user,
    website,
    _id,
    status,
    description,
    reason,
    category,
    target,
  } = merchantDetails;

  console.log("target", target);
  const handleBulkApprove = async (fundraiserId) => {
    try {
      const payload = { ids: [fundraiserId], status: "approved" };
      const res = await dispatch(approveOrRejectFundraiser(payload))?.unwrap();
      if (res?.success === true) {
        setStatusToggled(!statusToggled);
        if (typeof onStatusChange === 'function') {
          onStatusChange("approved");
        }
        try { toast.success("Fundraiser approved successfully"); } catch (_) { }
      }
    } catch (_) { }
  };

  const handleBulkDecline = async (fundraiserId) => {
    if (typeof onShowReviewModal === 'function') {
      // reuse review modal if needed
    }
    if (typeof onDecline === 'function') {
      onDecline(fundraiserId);
    }
  };

  return (
    <div
      style={{ scrollbarWidth: "none" }}
      className="max-h-[500px] overflow-y-auto w-full flex flex-col gap-2 justify-between font-poppins"
    >
      <div className="w-full flex justify-between items-center mb-4 gap-6">
        <div className="flex justify-start items-center gap-4 flex-1 min-w-0">
          {(() => {
            const raw = logo
              || merchantDetails?.logoUrl
              || merchantDetails?.profileImage
              || merchantDetails?.fundraiserLogo
              || merchantDetails?.user?.logo
              || merchantDetails?.user?.profileImage;
            // If logo exists and is not empty string
            if (raw && typeof raw === "string" && raw.trim() !== "") {
              const isFull = /^(http|https):\/\//i.test(raw);
              const src = (() => {
                if (isFull) return raw;
                const base = process.env.REACT_APP_S3_URL || "";
                if (base) {
                  const needsSlash = base.endsWith("/") ? "" : "/";
                  return `${base}${needsSlash}${raw}`;
                }
                const bucket = s3Config?.bucketName;
                const region = s3Config?.region;
                const dir = s3Config?.dirName ? `${s3Config.dirName}/` : "";
                return `https://${bucket}.s3.${region}.amazonaws.com/${dir}${raw}`;
              })();
              return (
                <img
                  src={src}
                  alt="Fundraiser logo"
                  className="w-[93px] h-[93px] object-cover rounded-full"
                  onError={(e) => {
                    // Fallback to placeholder if image fails to load
                    e.target.src = profileImagePlaceholderBlue;
                  }}
                />
              );
            }
            // No logo - show placeholder
            return (
              <div className="w-[93px] h-[93px] rounded-full flex items-center justify-center bg-[#E6F7FF] border border-[#00ADEF33]">
                <img
                  src={profileImagePlaceholderBlue}
                  alt="Default fundraiser avatar"
                  className="w-[70px] h-[70px] object-contain"
                />
              </div>
            );
          })()}
          <h1 className="font-[600] text-[20px] md:text-[22px] lg:text-[24px] truncate" title={user?.name}>
            {user?.name}
          </h1>
        </div>
        <div className="flex justify-between items-center gap-4 flex-shrink-0">
          <div className="flex items-center gap-3 flex-shrink-0">
            {(status === "approved" || status === "declined") && (
              <button
                type="button"
                onClick={() => onShowReviewModal && onShowReviewModal()}
                className="px-3 py-1 text/[12px] font-[500] text-[#00ADEF] border border-[#00ADEF] rounded-[4px] hover:bg-[#00ADEF] hover:text-white transition-colors whitespace-nowrap"
              >
                Review Status
              </button>
            )}
            {status === "approved" && <ApprovedIcon />}
            {status === "declined" && <DeclinedIcon />}
            {status === "pending" && <PendingIcon />}
          </div>
          {status === "pending" && (
            <DeleteIcon
              className="cursor-pointer"
              onClick={() => onDelete && onDelete(_id)}
            />
          )}
        </div>
      </div>
      {/* <div className="flex flex-col justify-start items-start gap-3">
        {category?.map((c, index) => (
          <div key={index} className="flex justify-start items-center gap-4">
            <img
              src={process.env.REACT_APP_IMG_URL + c?.image}
              alt="categoryImg"
              className="w-[30px] h-[30px]"
            />
            <h3>{c?.title}</h3>
          </div>
        ))}
      </div> */}
      {/* <div className="flex justify-start items-center flex-wrap gap-2 mt-2">
        {subCategory.map((option, index) => (
          <button
            key={index}
            //   onClick={() => handleOptionClick(option)}
            className={`px-4 py-1.5 rounded-full text-[13px] font-[500] bg-[#F1F1F1] text-[#767676]
              `}
          >
            {option?.title}
          </button>
        ))}
      </div> */}
      <div className="flex mt-4 justify-start items-center gap-2 text-[14px] font-[400] text-[#767676]">
        <CategoryIcon />
        <h3>{category[0]?.title}</h3>
      </div>
      <div className="flex mt-4 justify-start items-center gap-2 text-[14px] font-[400] text-[#767676]">
        <MapIcon />
        <h3>{address}</h3>
      </div>
      <div className="grid grid-cols-2 gap-4 mt-2">
        <div className="flex justify-start items-center gap-2 mt-1">
          <MailIcon />
          <p className="text-[14px] font-[400] text-[#767676]">{user?.email}</p>
        </div>
        <div className="flex justify-start items-center gap-3 mt-1">
          <WebIcon className="!w-[20px] !h-[20px]" />
          <p
            className="text-[14px] font-[400] text-[#767676] text-start truncate"
            title={website}
          >
            {website}
          </p>
        </div>
        <div className="flex justify-start items-center gap-2 mt-1 text-[14px] font-[400] text-[#767676]">
          <UserIcon />
          <p>{contactPersonName}</p>
        </div>
        <div className="flex justify-start items-center gap-2 mt-1 text-[14px] font-[400] text-[#767676]">
          <PhoneIcon />
          <p>{contactPersonNumber}</p>
        </div>
      </div>

      {/* <div className="flex flex-col gap-2 mt-4 text-[14px] font-[400] text-[#303030]">
        {tempLocations?.map((location, index) => (
          <div key={index} className="flex gap-2">
            <MapIcon />
            <h3>{location?.name}</h3>
          </div>
        ))}
      </div> */}

      {/* {stores?.length > 0 && <div className="w-full flex flex-col mt-4 gap-3 items-start font-poppins">
        <h2 className="text-[16px] font-[500] text-[#000000] text-start">
          Other Stores <span className="text-[#8C8C8C]">({stores?.length})</span>
        </h2>
        <StoresTable stores={stores} />
      </div>} */}

      <div className="w-full flex flex-col mt-4 gap-1 items-start font-poppins">
        <h2 className="text-[16px] font-[500] text-[#000000] text-start">
          Description:
        </h2>
        <p className="w-full text-start text-[14px] font-[400] text-[#767676]">
          {description || merchantDetails?.aboutUs || "No description available"}
        </p>
      </div>
      {
        reason?.length > 0 && (
          <div className="flex flex-col gap-1 mt-3">
            <h1 class="text-[16px] font-[500] text-start">Reasons:</h1>
            <ul className="list-disc pl-5 mb-5 text-[#767676] grid grid-cols-1 justify-items-start gap-4">
              {reason?.map((r, index) => (
                <li key={index} className="text-[14px] text-start">
                  {r?.reason}
                </li>
              ))}
            </ul>
          </div>
        )
      }
      <hr className="my-4" />
      {
        target?.targets?.length > 0 ? (
          <div className="w-full flex flex-col mt-4 gap-8 items-start font-poppins">
            <div className="w-full flex justify-start items-center gap-24">
              <div className="flex justify-start items-start gap-4">
                <CurrencyIcon />
                <div className="flex flex-col gap-1">
                  <h2 className="text-[16px] font-[500] text-[#000000] text-start">
                    Total Target:
                  </h2>
                  <p className="w-full text-start text-[14px] font-[400] text-[#767676]">
                    {`$${target?.totalTargetAmount}`}
                  </p>
                </div>
              </div>
              <div className="flex justify-start items-start gap-4">
                <CurrencyIcon />
                <div className="flex flex-col gap-1">
                  <h2 className="text-[16px] font-[500] text-[#000000] text-start">
                    Total Achieved:
                  </h2>
                  <p className="w-full text-start text-[14px] font-[400] text-[#767676]">
                    {`$${target?.totalAchievedAmount}`}
                  </p>
                </div>
              </div>
              <DatePicker
                picker="year"
                style={{
                  width: "80px",
                  border: "2px solid #00ADEF",
                  borderRadius: "8px",
                  padding: "4px 10px",
                  cursor: "pointer",
                  color: "#000000",
                  fontWeight: "500",
                  backgroundColor: "white",
                  hover: {
                    border: "2px solid #00ADEF !important",
                  },
                }}
                suffixIcon={<DownArrow />}
                value={dayjs(selectedYear || "2025")}
                format="YYYY"
                allowClear={false}
                onChange={(date, dateString) => {
                  // Using the dateString parameter provided by the DatePicker
                  if (dateString) {
                    setSelectedYear(dateString);
                    handleYearChange(_id, dateString);
                  }
                }}
                inputReadOnly={true}
              />
            </div>
            <TargetsTable fundraiserDetails={merchantDetails} />
          </div>
        ) : (
          <div className="w-full flex flex-col justify-center items-center gap-4">
            <CurrencyIcon className="!h-[52px] !w-[52px]" />
            <h2 className="text-[16px] font-[500] text-[#000000] text-start">
              No Fund Target has been set yet!
            </h2>
          </div>
        )
      }

      <div className="w-full flex justify-center items-center gap-4 mt-5 p-5 !pt-0">
        <PrimaryOutlineButton
          label={"Decline"}
          className={
            "w-[25%] !font-nunito text-[14px] font-[700] px-2 !h-[40px] rounded-[5px]"
          }
          onClick={() => handleBulkDecline(_id)}
          disabled={status !== "pending"}
        />
        <PrimaryButton
          className={
            "w-[25%] !h-[40px] rounded-[5px] text-[14px] font-[700] !font-nunito"
          }
          label="Approve"
          onClick={() => handleBulkApprove(_id)}
          disabled={status !== "pending"}
        />
      </div>

    </div >
  );
};

export default PopupContent;
